import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './Badge.scss';

const Badge = ({ onSelectBadge, isSelected, children }) => {
  const badgeClassname = classNames('badge__wrapper', {
    'badge__wrapper--is-selected': isSelected
  });
  return (
    <div
      className={badgeClassname}
      onClick={onSelectBadge}
      role="option"
      aria-selected={isSelected}
      aria-labelledby={children}
      tabIndex="0"
    >
      <span className="badge__text" id={children}>
        {children}
      </span>
    </div>
  );
};

Badge.propTypes = {
  onSelectBadge: PropTypes.func.isRequired,
  isSelected: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default Badge;
